module.exports = __webpack_public_path__ + "static/media/icon-plus.5a248ddb.svg";